const bn = {
  // Auth
  login: 'লগইন',
  register: 'নিবন্ধন',
  email: 'ইমেইল',
  password: 'পাসওয়ার্ড',
  name: 'নাম',
  phone: 'ফোন',
  confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
  forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
  dontHaveAccount: 'অ্যাকাউন্ট নেই?',
  alreadyHaveAccount: 'ইতিমধ্যে অ্যাকাউন্ট আছে?',
  createAccount: 'অ্যাকাউন্ত তৈরি করুন',
  signInToAccount: 'আপনার অ্যাকাউন্তে প্রবেশ করুন',
  
  // Navigation
  dashboard: 'ড্যাশবোর্ড',
  workers: 'ওয়ার্কার',
  sites: 'সাইট',
  attendance: 'হাজিরা',
  salary: 'বেতন',
  advances: 'অগ্রিম',
  settings: 'সেটিংস',
  profile: 'প্রোফাইল',
  logout: 'লগআউট',
  
  // Dashboard
  welcome: 'স্বাগতম',
  totalWorkers: 'মোট ওয়ার্কার',
  activeToday: 'আজ সক্রিয়',
  totalSites: 'মোট সাইট',
  pendingPayments: 'বকেয় বেতন',
  totalPendingAmount: 'মোট বকেয় পরিমাণ',
  thisWeek: 'এই সপ্তাহ',
  lastMonth: 'গত মাস',
  totalPaid: 'মোট পরিশোধিত',
  totalAdvance: 'মোট অগ্রিম',
  daysWorked: 'কাজের দিন',
  dailyRate: 'দৈনিক বেতন',
  grossAmount: 'মোট পরিমাণ',
  netAmount: 'নিট পরিমাণ',
  
  // Workers
  addWorker: 'ওয়ার্কার যোগ করুন',
  editWorker: 'ওয়ার্কার সম্পাদনা',
  deleteWorker: 'ওয়ার্কার মুছুন',
  workerName: 'ওয়ার্কারের নাম',
  workerList: 'ওয়ার্কার তালিকা',
  dailySalary: 'দৈনিক বেতন',
  
  // Sites
  addSite: 'সাইট যোগ করুন',
  editSite: 'সাইট সম্পাদনা',
  deleteSite: 'সাইট মুছুন',
  siteName: 'সাইটের নাম',
  siteLocation: 'সাইটের অবস্থান',
  siteDescription: 'সাইটের বিবরণ',
  assignWorkers: 'ওয়ার্কার নিয়োগ',
  
  // Attendance
  checkIn: 'চেক-ইন',
  checkOut: 'চেক-আউট',
  markAttendance: 'হাজিরা নিন',
  todayAttendance: 'আজকের হাজিরা',
  attendanceHistory: 'হাজিরার ইতিহাস',
  status: 'অবস্থা',
  present: 'উপস্থিত',
  absent: 'অনুপস্থিত',
  halfDay: 'আধা দিন',
  
  // Salary
  calculateSalary: 'বেতন গণনা',
  paymentHistory: 'পেমেন্ট ইতিহাস',
  markAsPaid: 'পরিশোধিত হিসাবে চিহ্নিত',
  pending: 'বকেয়',
  paid: 'পরিশোধিত',
  weekStart: 'সপ্তাহ শুরু',
  weekEnd: 'সপ্তাহ শেষ',
  
  // Advances
  requestAdvance: 'অগ্রিম অনুরোধ',
  approveAdvance: 'অগ্রিম অনুমোদন',
  rejectAdvance: 'অগ্রিম প্রত্যাখ্যান',
  advanceAmount: 'অগ্রিম পরিমাণ',
  advanceReason: 'অগ্রিমের কারণ',
  pendingRequests: 'বকেয় অনুরোধ',
  
  // Common
  save: 'সংরক্ষণ',
  cancel: 'বাতিল',
  edit: 'সম্পাদনা',
  delete: 'মুছুন',
  view: 'দেখুন',
  search: 'অনুসন্ধান',
  filter: 'ফিল্টার',
  date: 'তারিখ',
  from: 'থেকে',
  to: 'পর্যন্ত',
  loading: 'লোড হচ্ছে...',
  noData: 'কোনো তথ্য নেই',
  success: 'সফল',
  error: 'ত্রুটি',
  confirm: 'নিশ্চিত করুন',
  
  // Theme
  lightMode: 'লাইট মোড',
  darkMode: 'ডার্ক মোড',
  
  // Language
  bangla: 'বাংলা',
  english: 'ইংরেজি',
};

export default bn;
